import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/shm.png";
import "../styles/global.css";

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">
          <img src={Logo} alt="Southern Homemove Ltd" />
        </Link>
      </div>
      
      <div className="burger-menu-container">
        <button 
          className={`burger-menu ${isMenuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span className="burger-line"></span>
          <span className="burger-line"></span>
          <span className="burger-line"></span>
        </button>
        
        <div className={`dropdown-menu ${isMenuOpen ? 'open' : ''}`}>
          {location.pathname !== "/contact" && (
            <Link to="/contact" onClick={closeMenu}>Contact Us</Link>
          )}
          {location.pathname === "/contact" && (
            <>
              <Link to="/" onClick={closeMenu}>Home</Link>
              <Link to="/land-new-homes" onClick={closeMenu}>Land & New Homes</Link>
            </>
          )}
          {location.pathname === "/" && (
            <Link to="/land-new-homes" onClick={closeMenu}>
              Land & New Homes
            </Link>
          )}
          {location.pathname === "/land-new-homes" && (
            <Link to="/" onClick={closeMenu}>Home</Link>
          )}
        </div>
      </div>

      {isMenuOpen && (
        <div className="menu-overlay" onClick={closeMenu}></div>
      )}
    </header>
  );
};

export default Header;